<template>
  <BaseDialog
    title="customer Location"
    v-model="customerLocationDialog"
    maxWidth="50%"
    cardTextClass="px-0 pb-0"
  >
    <template #information>
      <GoogleMap
        :hasMapInfo="true"
        id="customerLocation"
        mapWidth="10vw%"
        mapHeight="50vh"
        ref="customerLocation"
        :clusterMarkers="true"
      >
        <template #mapInfo>
          <MapInfo legendType="customer_address_location" />
        </template>
      </GoogleMap>
    </template>
  </BaseDialog>
</template>
  
  <script>
import BaseDialog from "@/components/BaseComponents/BaseDialog.vue";
import GoogleMap from "@/components/BaseComponents/GoogleMap.vue";
import MapInfo from "@/components/BaseComponents/MapInfo.vue";

import { bus } from "@/main";
export default {
  components: { BaseDialog, GoogleMap, MapInfo },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    templateId: {
      type: [Number, null],
    },
  },
  data() {
    return {
      customerDetails: {},
    };
  },
  computed: {
    customerLocationDialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    getCustomerAddressMapDetails(id) {
      bus.$emit("showLoader", true);
      this.$api.customerAddress
        .getCustomerAddressMapDetails(id)
        .then((res) => {
          this.customerDetails = res.data;
          this.customerDetails.icon = "customer";

          const interval = setInterval(async () => {
            if (window.google && window.google.maps && this.$refs.customerLocation.map) {
              clearInterval(interval);
              this.$refs.customerLocation.removeAllMarkers();
              this.$refs.customerLocation.initBounds();
              if (
                this.customerDetails &&
                this.customerDetails.coordinates &&
                this.customerDetails.coordinates.longitude &&
                this.customerDetails.coordinates.latitude
              ) {
                this.$refs.customerLocation.setCustomMaker({
                  icon: "customer",
                  ...this.customerDetails,
                  ...this.customerDetails.customer_details,
                });
              }
              if (
                this.customerDetails &&
                this.customerDetails.serviceable_area
              ) {
                this.$refs.customerLocation.clearGeoJson()
                this.$refs.customerLocation.addFeatures([
                  {
                    geometry: this.customerDetails.serviceable_area,
                    type: "Feature",
                  },
                ]);
              }
            }
          }, 100);
          setTimeout(() => {
            clearInterval(interval);
          }, 1000);

          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
  },
};
</script>
  
  <style></style>
  